import React, { Fragment } from "react";
import { getServerEndpoint } from "../../../utils/serverEndpoint";
import { sanitizedFilename } from "../../../utils/utils";
import { fetchStaticResource } from "../../../utils/utils";

const SIGNATURES_ALT_TEXT = "Image not found!";
let path = getServerEndpoint() + "applicationresources" + "/";

class SignatureImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSrc: null,
    };
  }

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.signatureImage !== this.props.signatureImage) {
      this.loadImage();
    }
  }

  loadImage() {
    const { signatureImage } = this.props;
    if (signatureImage) {
      fetchStaticResource(path + signatureImage).then((data) => {
        this.setState({ imageSrc: data });
      });
    }
  }

  render() {
    const { sigIsOptional, userName, placement, overRideContainerStyle } = this.props;
    const { imageSrc } = this.state;

    let containerStyle = placement === "tableCell" ? "cell-signature-image" : "signature-image";
    if (overRideContainerStyle) {
      containerStyle = overRideContainerStyle;
    }

    return (
      <React.Fragment>
        {(this.props.signatureImage || sigIsOptional) && (
          <div className={containerStyle}>
            {imageSrc ? <img src={imageSrc} alt={SIGNATURES_ALT_TEXT} /> : null}
            <div style={{ textAlign: "center" }}>{userName}</div>
          </div>
        )}
      </React.Fragment>
    );
  }
}
export default SignatureImage;

class SignatureImageImproved extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imageSrc: null,
    };
  }

  componentDidMount() {
    this.loadImage();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.signatureImage !== this.props.signatureImage) {
      this.loadImage();
    }
  }

  loadImage() {
    const { signatureImage } = this.props;
    if (signatureImage) {
      fetchStaticResource(path + signatureImage).then((data) => {
        this.setState({ imageSrc: data });
      });
    }
  }

  render() {
    const { width, userName, underline, underlineTitle, forceRender } = this.props;
    const { imageSrc } = this.state;

    return (
      <React.Fragment>
        {(this.props.signatureImage || forceRender) && (
          <Fragment>
            <div className={"cell-signature-imporved-image"} style={{ borderBottom: underline ? "1px solid" : "none" }}>
              {imageSrc ? (
                <img src={imageSrc} alt={SIGNATURES_ALT_TEXT} style={{ width: width ? width : "100%", paddingBottom: "2px" }} />
              ) : null}
              <div style={{ textAlign: "center" }}>{userName}</div>
            </div>
            {underline && underlineTitle ? <div style={{ textAlign: "center", fontWeight: 600 }}>{underlineTitle}</div> : null}
          </Fragment>
        )}
      </React.Fragment>
    );
  }
}
export { SignatureImage, SignatureImageImproved };



// WEBPACK FOOTER //
// ./src/components/Reports/utils/SignatureImage.jsx